
	import { Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import Component from 'vue-class-component';
	import accommodations from '@/store/prescription/definition/categories/accommodations';
	import CategoryContainer from './CategoryContainer.vue';
	import PrescriptionItemRadio from '@/components/new-prescription/prescription-items/PrescriptionItemRadio.vue';
	import PrescriptionItemCheckbox from '@/components/new-prescription/prescription-items/PrescriptionItemCheckbox.vue';
	import { reaction } from 'mobx';
	import OtherModifications from '@/components/prescription/OtherModifications.vue';
	import PrescriptionStore from '@/store/prescriptionStore';
	import { ACCOMMODATIONS_SPECIAL_RX } from '@/store/prescription/prescription-types';
	import PrescriptionItemSpecialRX from '@/components/new-prescription/prescription-items/PrescriptionItemSpecialRX.vue';
	import PrescriptionItemRadioSelect from '@/components/new-prescription/prescription-items/PrescriptionItemRadioSelect.vue';
	import PrescriptionItemExtendedSelectLR from '@/components/new-prescription/prescription-items/PrescriptionItemExtendedSelectLR.vue';
	import { getDisabledValuesBySideForProp } from '@/store/prescription/prescription-utils';
	@Observer
	@Component({
		components: {
			PrescriptionItemRadioSelect,
			PrescriptionItemCheckbox,
			PrescriptionItemRadio,
			CategoryContainer,
			OtherModifications,
			PrescriptionItemSpecialRX,
			PrescriptionItemExtendedSelectLR
		}
	})
	export default class Accommodations extends Vue {
		activated() {
			if (this.$route.query['showhelpmodal'] === 'true') {
				this.$state.prescription.setShowHelpSaverxModal('true');
			}
		}
		get accommodationsSpecialRX() {
			return ACCOMMODATIONS_SPECIAL_RX;
		}
		deactivated() {
			this.$state.prescription.setShowHelpSaverxModal('false');
		}
		get accommodations() {
			return accommodations;
		}

		mounted() {
			reaction(
				() => this.$state.prescription.newPrescription.accommodations.balancePad?.left,
				(value) => {
					if (!PrescriptionStore.isSorted(value)) {
						this.$state.prescription.newPrescription.accommodations.balancePad.left = [...value].sort();
					}
				}
			);

			reaction(
				() => this.$state.prescription.newPrescription.accommodations.balancePad?.right,
				(value) => {
					if (!PrescriptionStore.isSorted(value)) {
						this.$state.prescription.newPrescription.accommodations.balancePad.right = [...value].sort();
					}
				}
			);

			reaction(
				() => this.$state.prescription.newPrescription.accommodations.neuromaPad?.left,
				(value) => {
					if (!PrescriptionStore.isSorted(value)) {
						this.$state.prescription.newPrescription.accommodations.neuromaPad.left = [...value].sort();
					}
				}
			);

			reaction(
				() => this.$state.prescription.newPrescription.accommodations.neuromaPad?.right,
				(value) => {
					if (!PrescriptionStore.isSorted(value)) {
						this.$state.prescription.newPrescription.accommodations.neuromaPad.right = [...value].sort();
					}
				}
			);
		}

		heelCushionDisabledValues() {
			return getDisabledValuesBySideForProp(this.$state, 'heelCushion');
		}

		heelSpurPadDisabledValues() {
			return getDisabledValuesBySideForProp(this.$state, 'heelSpurPad');
		}

		metBarDisabledValues() {
			return getDisabledValuesBySideForProp(this.$state, 'metBar');
		}

		metPadsDisabledValues() {
			return getDisabledValuesBySideForProp(this.$state, 'metPads');
		}
	}
